
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function BlogNav() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/95 backdrop-blur-lg shadow-lg shadow-amber-500/10' : 'bg-black/80 backdrop-blur-md'
      }`}
    >
      <div className="w-full px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-12">
            <button
              onClick={() => navigate('/')}
              className="text-white/80 hover:text-amber-400 transition-all duration-300 font-light tracking-wider text-sm hover:drop-shadow-[0_0_8px_rgba(251,191,36,0.8)] whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
            >
              首頁
            </button>
            <button
              onClick={() => navigate('/blog')}
              className="text-amber-400 transition-all duration-300 font-light tracking-wider text-sm drop-shadow-[0_0_8px_rgba(251,191,36,0.8)] whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
            >
              教學
            </button>
          </div>

          <button
            onClick={() => navigate('/#contact')}
            className="px-6 py-2.5 bg-gradient-to-r from-amber-500 to-yellow-400 rounded-sm text-black text-sm font-bold tracking-widest hover:shadow-lg hover:shadow-amber-500/50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
          >
            合作洽詢
          </button>
        </div>
      </div>
    </nav>
  );
}
